import React from "react";
import ReactECharts from "echarts-for-react";

const Piechart = ({ data = [] }) => {
    // Transform API data -> ECharts format
    const chartData = data?.result?.map(item => ({
        value: item.doc_count,
        name: item.key
    })) || [];

    const option = {
        title: {
            // text: "Driver Training Data",
            // left: "center",
        },
        tooltip: {
            trigger: "item",
        },
        legend: {
            orient: "vertical",
            left: "left",
        },
        series: [
            {
                name: "Driver Training",
                type: "pie",
                radius: "60%",
                data: chartData,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                },
            },
        ],
    };

    return (
        <div className="w-full flex ">
            <ReactECharts option={option} style={{ height: 180, width: "100%" }} />
        </div>
    );
};

export default Piechart;
